
import React, { useEffect } from 'react';
import './App.css';
import AppRoutes from './appRoutes'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './store/features/loader';
import { TRANSLATION_API } from './apiUrls';
import api from './apiUrls/api';
import { setLabels } from './store/features/language';
import { Alert, Snackbar } from '@mui/material';
import { closeToast } from './store/features/toast';
import { TableRowsTwoTone } from '@mui/icons-material';


function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {language} = useSelector(state => state.language)

  useEffect(() => {
    if (location.pathname === '/') {
      // navigate('/selfScheduler/homePage');
     let clientName = localStorage.getItem('client_name')
      if (clientName) {
        navigate('/211SelfScheduler/'+clientName, { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  const fetchAndSetLabels = () => {
    api.POST(TRANSLATION_API, {
      language_prefix: 'en'
    }).then(res => {
      dispatch(setLabels(JSON.parse(res.data?.obj?.json_values)))
    }).catch(err => {
      console.log(err)
    })
  }

  useEffect(() => {
    fetchAndSetLabels()
  }, [])

  const open = useSelector((state) => state.loader.open);
  const toast = useSelector((state) => state.toast);

  const handleToastClose = () => {
    dispatch(closeToast());
  };

  return (
    <>
    {/* <Loader/> */}
    <Snackbar sx={{ zIndex: 1000 }} open={toast.open} autoHideDuration={4000} onClose={handleToastClose}>
        <Alert onClose={handleToastClose} variant="filled" severity={toast.severity} sx={{ width: '100%', fontSize: '16px'}}>
          {toast.message}
        </Alert>
      </Snackbar>
    <AppRoutes/>
    </>
    // {open && <Loader/>}
  
       
  );
}

export default App;
